<template>
  <div>
    <div class="quoteheadertop">
      <div class="flexrow">
        <h2>Quote</h2>
        <div class="pushright">
          <v-icon size="18px">date_range</v-icon>
          <router-link :to="diaryLink">Quote diary</router-link>
        </div>
      </div>
      <div class="flexrow">
        <div v-if="quote.instructed == 1">
          <v-btn
            :to="{ name: 'createFileOld', params: { id: $route.params.id } }"
            v-if="!quote.files.length"
          >
            <v-icon>folder</v-icon>Create file(s)
          </v-btn>
          <div v-if="quote.files.length">
            <div v-for="file in quote.files" :key="file.id">
              <FileGql :file="file" />
            </div>
          </div>
        </div>
        <div class="pushright">
          <v-icon size="18px">picture_as_pdf</v-icon>
          <a @click="download">View pdf</a>
          <Spacer />
          <v-icon>refresh</v-icon>
          <router-link :to="overwriteLink" small>Overwrite</router-link>
        </div>
      </div>
      <div class="flexrow">
        <div class="pushright">
          <template v-if="quote.instructed == 0">
            <strong>Quote</strong>
            <Spacer />
            <a @click="convert(2)">Enquiry</a>
            <Spacer />
            <span style="color: gray">Instruction</span>
          </template>
          <template v-if="quote.instructed == 1">
            <span style="color: gray">Quote</span>
            <Spacer />
            <span style="color: gray" v-if="quote.files.length">Enquiry</span>
            <a @click="convert(2)" v-if="!quote.files.length">Enquiry</a>
            <Spacer />
            <strong>Instruction</strong>
          </template>
          <template v-if="quote.instructed == 2">
            <a @click="convert(0)">Quote</a>
            <Spacer />
            <strong>Enquiry</strong>
            <Spacer />
            <a @click="convert(1)">Instruction</a>
          </template>
        </div>
      </div>
    </div>
    <div :class="`quoteHeader${quote.instructed}`" id="quoteHeader">
      <div class="quoteHeaderHeading" v-if="heading">{{ heading }}</div>
      <v-layout row>
        <v-flex xs4 md2>
          <strong>Id</strong>
        </v-flex>
        <v-flex xs8 md4>{{ quote.id }}</v-flex>
        <v-flex xs4 md2>
          <strong>User</strong>
        </v-flex>
        <v-flex xs8 md4>
          <EntityZ v-if="quote.user" :entity="quote.user" format="system" />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4 md2>
          <strong>Time</strong>
        </v-flex>
        <v-flex xs8 md4>{{ quote.timestamp | formatDateTime }}</v-flex>
        <v-flex xs4 md2>
          <strong>Ip address</strong>
        </v-flex>
        <v-flex xs8 md4>
          <span :class="quote.blacklist ? 'ipAddressBlack' : 'ipAddress'">{{
            quote.ipaddress
          }}</span>
          <a @click="ban(true)" v-if="!quote.blacklist">ban</a>
          <a @click="ban(false)" v-if="quote.blacklist">unban</a>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4 md2>
          <strong>User agent</strong>
        </v-flex>
        <v-flex xs8 md4>
          <span v-if="quote.userAgent">{{ quote.userAgent.body }}</span>
        </v-flex>
        <v-flex xs4 md2>
          <strong>Nbm uid</strong>
        </v-flex>
        <v-flex xs8 md4>{{ quote.nbmuid }}</v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import FileGql from "@/components/link/FileGql";
import Spacer from "@/components/layout/Spacer";
import { format, parseISO } from "date-fns";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Header",
  props: ["quote", "lastUpdated"],
  components: { EntityZ, FileGql, Spacer },
  computed: {
    diaryLink() {
      return {
        name: "diary",
        query: { date: format(parseISO(this.quote.timestamp), "yyyyMMdd") }
      };
    },
    overwriteLink() {
      return {
        name: "quoteQuestions",
        params: { quoteTypeId: this.quote.quoteType.id },
        query: { overwriteId: this.quote.id }
      };
    }
  },
  data() {
    return {
      heading: null
    };
  },
  methods: {
    async fetchHeading() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/quotes/${this.$route.params.id}/heading`
      );
      // console.log(response.data);
      this.heading = response.data;
    },
    download() {
      window.open(
        `${process.env.VUE_APP_CT_URL}/cors/admin/sales/quotes/${this.$route.params.id}/pdf`,
        "_blank"
      );
    },
    async convert(instructed) {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/convert/${instructed}`,
        null
      );
      // console.log(response.data);
      this.$emit("triggerUpdate");
    },
    async ban(value) {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}/ban/${value}`,
        null
      );
      // console.log(response.data);
      this.$emit("triggerUpdate");
    }
  },
  watch: {
    lastUpdated: {
      immediate: true,
      handler() {
        this.fetchHeading();
      }
    }
  }
};
</script>

<style>
.quoteheadertop {
  display: flex;
  flex-direction: column;
}
.quotelinks {
  display: flex;
}
.quotelinks h2 {
  float: left;
}
.quoteheadertop .flexrow {
  display: flex;
}
.quoteheadertop .flexrow .pushright {
  flex-grow: 1;
  text-align: right;
}
</style>